<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useSharedUi } from '@/composables/useSharedUi'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import CustomButton from '@/components/customButton/CustomButton.vue'

const isActive = ref(false)
const router = useRouter()
const { t } = useI18n()
const { hideMessageMenu } = useSharedUi()
const { createUmsokn } = useUmsokn()

const props = defineProps<{
  setLoading?: (value: boolean) => void
}>()


const APP_ID = 5

async function openApplication() {
  isActive.value = true
  try {
    props.setLoading?.(true)
    const newApp = await createUmsokn(APP_ID)
    if (newApp) {
      hideMessageMenu()
      const step =
        newApp.currentStep && newApp.currentStep > 0
          ? newApp.currentStep + 1
          : 1
      router.push({ query: { step: String(step) } })
    } else {
      // optional: surface a toast here if you use one
      console.error('Application was not created.')
    }
  } catch (err) {
    console.error('Failed to create application:', err)
  } finally {
    props.setLoading?.(false)
  }
}
</script>

<template>
  <div>
    <v-container class="scrollview">
      <v-row justify="center">
        <v-col>
          <h1 :class="[isActive ? 'active' : '', 'heading']">
            {{ t('umsokn_sereignbreyting_begin_header') }}
          </h1>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col md="7">
          <p>{{ t('umsokn_sereignbreyting_begin_text') }}</p>
        </v-col>
      </v-row>


      <v-row justify="center">
        <v-col md="7">
          <p class="forms__header">
            {{ t('umsokn_sereignbreyting_begin_disclaimer_header') }}
          </p>
          <p style="font-size:16px">
            {{ t('ororku_umsokn_begin_disclaimer_text') }}
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-center">
          <CustomButton @click="openApplication">
            {{ t('sereignar_umsokn_begin_button') }}
          </CustomButton>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
h1 {
  color: #194458;
  font-size: 55px;
  font-weight: 900;
  line-height: 75px;
  text-align: center;
}
p {
  color: #194458;
  font-size: 21px;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}
.heading {
  position: relative;
  font-size: 55px;
}
.active {
  transition: all 0.8s linear;
  top: -900px;
  height: 20px;
  color: #194458;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
}
.center__content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.router__btn > button {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  line-height: 27px;
  border-radius: 5px;
  background: linear-gradient(180deg, #00bcb3 0%, #00877c 100%);
  height: 60px;
  width: 173px;
}
@media (max-width: 768px) {
  .scrollview {
    overflow-y: scroll;
    padding-bottom: 91px;
  }
}
</style>
